export default function initStickyAnchorPanel() {
	const $win = jQuery(window);
	let $main = jQuery('#main');

	if (!$main.length) {
		$main = jQuery('#wrapper');
	}

	const getWindowHeight = function() {
        return window.innerHeight || document.documentElement.clientHeight;
    };

    jQuery('.nav-page-panel').each(function() {
		const $panel = jQuery(this);
		const $scrollable = $panel.find('.nav-page-list');
        let offsetTop = 0;
        let winHeight = getWindowHeight();
        let flag = false;
        let flagMobile = false;

        function resizeHandler() {
            offsetTop = $panel.offset().top;
            winHeight = getWindowHeight();

            scrollHandler();
        }

        function scrollHandler() {
        	// desktop
            if ($win.scrollTop() > offsetTop - parseInt(jQuery('html').css('--header-height'))) {
                if (!flag) {
                    $panel.addClass('fixed-position')
                    flag = true;
                }
            } else {
                if (flag) {
                    $panel.removeClass('fixed-position')
                    flag = false;
                }
            }

            // mobile
            if ($win.scrollTop() > 20 && $win.scrollTop() < $main.offset().top + $main.innerHeight() - winHeight) {
                if (!flagMobile) {
                    $panel.addClass('fixed-position-mobile')
                    flagMobile = true;
                }
            } else {
                if (flagMobile) {
                    $panel.removeClass('fixed-position-mobile')
                    flagMobile = false;
                }
            }
        }

        resizeHandler();
        $win.on('scroll', scrollHandler).on('load resize orientationchange', resizeHandler);

        $panel.on('toggleActiveClass', 'a', function (e, state) {
            const $anchor = jQuery(e.currentTarget);

            if ($anchor.data('prevState') !== state) {
                if (state) {
                    const offset = $scrollable.scrollLeft() - $scrollable.offset().left + $anchor.offset().left;
                    const scrollLeft = offset - $scrollable.innerWidth() / 2 + $anchor.innerWidth() / 2;

                    $scrollable.stop().animate({ scrollLeft: scrollLeft }, 400);
                }
            }

            $anchor.data('prevState', state);
        });
	});
}